import React from 'react'
import { Redirect } from 'react-router-dom'

const PrivateRoute = ({ Component, isAuthenticated, child, isHeader, isFooter }) => {
  return isAuthenticated
    ? (
      <Component child={child} />
      )
    : (
      <Redirect to={{ pathname: '/' }} />
      )
}

export default PrivateRoute
